import ShopSupplierResourceListResultModel from '../../generated/types/model/resource/ShopSupplierResourceListResultModel';

export default class ShopSupplierResourceListResultViewModel extends ShopSupplierResourceListResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
